function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.77082 4.71687L1.06373 7.28133C0.815004 7.57999 0.38726 7.57153 0.148292 7.26322C-0.0545418 7.00154 -0.0486537 6.61281 0.16199 6.35883L2.68977 4L0.16199 1.64117C-0.0486543 1.38719 -0.0545418 0.998464 0.148292 0.736775C0.38726 0.428469 0.815004 0.420007 1.06373 0.718666L3.77082 3.28313C3.77082 3.28313 4 3.5763 4 4C4 4.4237 3.77082 4.71687 3.77082 4.71687Z",
  fill: "#626262"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.77082 4.71687L1.06373 7.28133C0.815004 7.57999 0.38726 7.57153 0.148292 7.26322C-0.0545418 7.00154 -0.0486537 6.61281 0.16199 6.35883L2.68977 4L0.16199 1.64117C-0.0486543 1.38719 -0.0545418 0.998464 0.148292 0.736775C0.38726 0.428469 0.815004 0.420007 1.06373 0.718666L3.77082 3.28313C3.77082 3.28313 4 3.5763 4 4C4 4.4237 3.77082 4.71687 3.77082 4.71687Z",
  fill: "#69707D"
});

const SvgExpand = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgExpand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expand.4dbf0fe0.svg";
export { ForwardRef as ReactComponent };